
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm employee-sports">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Expre<span >ssions</span></h2>
            <p>(Presentation through Kathak by Guru Smt. Priyanka Abhyankar)</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-9">
                <div class=" text-justify">
                    <h2 class="head-lea">GURU SMT. PRIYANKA ABHYANKAR <span class="small-sm">06 AUGUST 2019</span></h2>
                    <p>Guru Smt. Priyanka Abhyankar, the founder and director of Sanskar Kathak Kendra, has completed
                        her Kathak Visharad from Akhil Bhartiya Gandharva Mahavidyala, Mumbai in the year 1994, under
                        the guidance of her Guru Mrs. Deepa Biswas. The institute, 'Sanskar Kathak Kendra', which she
                        founded in the year 1999 and has mothered over all these years has now completed 20 glorious
                        years. Sanskar Kathak Kendra has 3 branches in Nagpur. Presently more than 200 students are
                        being trained in kathak by her.</p>
                    <p>Guru Smt. Priyanka Abhyankar, the founder and director of Sanskar Kathak Kendra, has completed
                        her Kathak Visharad from Akhil Bhartiya Gandharva Mahavidyala, Mumbai in the year 1994, under
                        the guidance of her Guru Mrs. Deepa Biswas. The institute, 'Sanskar Kathak Kendra', which she
                        founded in the year 1999 and has mothered over all these years has now completed 20 glorious
                        years. Sanskar Kathak Kendra has 3 branches in Nagpur. Presently more than 200 students are
                        being trained in kathak by her.</p>
                </div>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/priyanka.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <p>She is also an External examiner for Kathak exams conducted by Akhil Bharatiya Gandharva Mahavidyala,
                Miraj. She has been invited on various occasions as flag bearer of Kathak, the art form she worships in
                events like 'Krishnamayookhyam Dance Festival', 'Essence- The Fragrance of Kathak', Nagpur’s first
                'Orange city International Film Festival'.</p>
            <p>She has also conceptualised and choreographed dances for various theatre dramas like 'Yugandhar',
                'Krishna Baawri', and ‘Stri Sukta- Ek Natyavishkar'.</p>
            <p>She is a very well-known face in the dance fraternity of Nagpur and is often bestowed with the batten to
                add the beautiful element of dance to various programs and shows that are staged across the city which
                includes shows for the Physics Department of Nagpur University, Urban Mobility India Conference and Expo
                and many more.</p>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-9">
                <h6 class="fw-bold">Let’s meet you then.</h6>
                <p>Topic: Expressions (Presentation through Kathak)</p>
                <p>Date: Tuesday, 6 <sup>th</sup> August 2019</p>
                <p>Time : 7.00 Pm</p>
                <p>Venue: Chitnavis Centre, Besides Hislop College, Civil Lines, Nagpur</p>
            </div>
            <div class="col-md-3">
                <div class="image-effect-3">
                    <h6 class="fw-bold"> INVITATION</h6>
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/Priyanka_Invitation.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Media Coverage</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230" src="https://urlzs.com/NbNdX" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Videos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>

                </div>
                <iframe width="100%" height="230" src="https://www.youtube.com/embed/_Krm8OJqnXE" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/pa_kathak_5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</section>
